var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconFlag(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 18,
    viewBox: "0 0 16 18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.027,8.15a3.928,3.928,0,0,1-2.435-.323,5.118,5.118,0,0,0-3.153-.363,5.564,5.564,0,0,0-2.8,1.811l-.075-.359L1.5,3.822A4.223,4.223,0,0,1,4.1,1.811c1.087-.224,2.017.517,3.095,1.374,1.045.831,2.228,1.77,3.681,1.706a6.041,6.041,0,0,0,3.446-1.677C13.888,5.565,12.814,7.71,11.027,8.15ZM15.42.134A.718.718,0,0,0,14.6.6c-.2.5-2.12,2.653-3.787,2.729a4.621,4.621,0,0,1-2.754-1.4C6.879.986,5.54-.079,3.827.274A5.868,5.868,0,0,0,.079,3.338a.836.836,0,0,0-.061.527L.749,7.359h0L2.874,17.507a.741.741,0,0,0,.709.611.677.677,0,0,0,.161-.019.785.785,0,0,0,.55-.935l-1.24-5.926A4.814,4.814,0,0,1,5.763,8.99a3.847,3.847,0,0,1,2.369.322,5.2,5.2,0,0,0,3.219.364C14.084,9,15.953,5.48,16,.909A.772.772,0,0,0,15.42.134Z",
    transform: "translate(0 -0.118)",
    fill: "#006",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconFlag);
export default __webpack_public_path__ + "static/media/icon-flag.22b4292ab81e8e6c595237ca49e99840.svg";
export { ForwardRef as ReactComponent };